import React, { FC } from 'react';
import { DraggableComponentProps } from 'features/document/constants';
import { isTextFieldElement } from 'utils/typeGuards';
import { Container, Label, Textfield } from './TextField.styled';

const TextField: FC<DraggableComponentProps> = ({ currentElement }) => {
  if (!isTextFieldElement(currentElement)) {
    return null;
  }

  const { labelColor, labelFont, labelFontSize } = currentElement.style;
  const { label, placeholder, required, value } = currentElement.content;

  return (
    <Container>
      <Textfield
        autoComplete='off'
        id={currentElement.id}
        placeholder={placeholder}
        required={required}
        value={value}
      />
      <Label htmlFor={currentElement.id} labelColor={labelColor} labelFont={labelFont} labelFontSize={labelFontSize}>
        {label}
      </Label>
    </Container>
  );
};

export default TextField;
